import { css } from '@emotion/react';
import { type FC } from 'react';
import { Trans } from 'react-i18next';
import { Stack } from '~/_shared/baseComponents/layout/Stack.componment';
import { LinkComponent } from '~/_shared/baseComponents/links';
import { SupportLinkComponent } from '~/_shared/baseComponents/links/supportLink/supportLink.component';
import { LOGIN_ROUTE } from '~/_shared/constants/routes';
import {
  Breakpoint, mq,
} from '~/_shared/style.mixins';
import { useTranslation } from '~/_shared/utils/hooks';

const alreadyUserSectionStyle = css({
  cursor: 'default',
  fontSize: 18,
  fontWeight: 700,
  textAlign: 'start',
  width: '100%',
  [mq(Breakpoint.mid)]: {
    width: 'unset',
  },
});

const alreadyUserLinkStyle = css({
  fontSize: 18,
});

const enterpriseSectionStyle = css({
  cursor: 'default',
  fontSize: 14,
});

const enterpriseHeadingStyle = css({
  fontWeight: 700,
  margin: 0,
});

const enterpriseDescriptionStyle = css({
  margin: 0,
});

export const RegisterFormFooter: FC = () => {
  const [t] = useTranslation();

  return (
    <>
      <p css={alreadyUserSectionStyle}>
        {t('Already a user?') + ' '}
        <LinkComponent
          css={alreadyUserLinkStyle}
          path={LOGIN_ROUTE}
        >
          {t('Log in here')}
        </LinkComponent>
      </p>

      <Stack
        css={enterpriseSectionStyle}
        gap={2}
      >
        <p css={enterpriseHeadingStyle}>{t('signup.plans.enterpriseAvailable')}</p>
        <p css={enterpriseDescriptionStyle}>
          <Trans
            i18nKey="signup.plans.customTerms"
            components={{
              support: <SupportLinkComponent />,
            }}
          />
        </p>
      </Stack>
    </>
  );
};
